import BrandMonthlyReport from './BrandMonthlyReport';

// Wunder · ASICS Eylül raporu (ASICS "geçtiğimiz ayın sonuçları" talebi). 21 Eki: ürün/collab
// tablosu kaldırıldı (Efe: "ürünlerin tamamını kaldıralım").

const CONFIG = {
  title: 'ASICS · Eylül Kampanya Raporu',
  campaignLike: 'asics',
  ikasBrand: 'ASICS',
  brandLabel: 'ASICS',
  logo: '/asicslogo.png',
  minDate: null,
  campaignNote: 'ASICS kampanyaları',
  presets: [
    { label: 'Eylül', start: () => new Date(2026, 8, 1), end: () => new Date(2026, 8, 30) },
    { label: 'Ağu–Eyl', start: () => new Date(2026, 7, 1), end: () => new Date(2026, 8, 30) },
    { label: 'Ekim', start: () => new Date(2026, 9, 1), end: () => new Date() },
  ],
};

export default function AsicsCampaignReport() {
  return <BrandMonthlyReport config={CONFIG} />;
}
